import { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';

import { gameChanged } from '../../modules/global/action-creators';

/**
 * Game controller component
 * Used to alert redux to url game selection
 */
class GameController extends PureComponent {
  componentDidMount() {
    this.checkGame();
  }
  componentDidUpdate() {
    this.checkGame();
  }
  checkGame() {
    const urlGameId = this.props.gameId;
    if (this.props.registeredGameId !== urlGameId) {
      return this.props.gameChanged(urlGameId);
    }
  }

  render() {
    return null;
  }
}

GameController.propTypes = {
  gameId: PropTypes.string.isRequired
};

/**
 * Map Redux State to props
 */
const mapStateToProps = ({ global }) => ({
  registeredGameId: global.gameId
});

/**
 * Map Redux Dispatch to props
 */
const mapDispatchToProps = dispatch => ({
  ...bindActionCreators(
    {
      gameChanged
    },
    dispatch
  )
});

export default connect(mapStateToProps, mapDispatchToProps)(GameController);
